export const FEATURE_FLAGS = {
  IS_ADMINHUB_INTEGRATION_ENABLED: 'UI_AdminHub_Integration',
  IS_APPCUES_ON: 'UI_Appcues_Enabled',
  IS_REFERRAL_PROGRAM_ENABLED: 'ReferralProgram_IsEnabled',
  IS_NEW_INCENTIVE_SETTINGS_ENABLED: 'Use_New_Dynamic_Incentive_Models',
  IS_BUYER_BLOCKING_ENABLED: 'Is_BuyerBlocking_Enabled',
  IS_PANEL_BUYER_BLOCKING_ENABLED: 'Is_PanelBuyerBlocking_Enabled',
  IS_RECOMMENDED_SETTING_ENABLED: 'UI_Recommended_Setting',
  IS_MAX_PARTICIPANT_REROUTE_ATTEMPTS_ENABLED:
    'Max_Participant_Reroute_Attempts',
  IS_PRIORITY_STATUS_ENABLED: 'PriorityStatusEnabled',
  IS_TREMENDOUS_MULTITENANT_ENABLED: 'Enable_Tremendous_Multitenant',
  IS_ENTRY_LINK_TYPE_ENABLED: 'IS_ENTRY_LINK_TYPE_ENABLED',
  IS_PII_STUDY_ELIGIBILITY_ENABLED: 'PII_Study_Eligibility_IsEnabled',
  IS_NEW_MARKETING_CAMPAIGN_ENABLED: 'New_Marketing_Campaign_Enabled',
  IS_GOOGLE_MARKETING_SIGNALS_ENABLED: 'Google_Marketing_Signals_Enabled',
} as const;
